import addReadWriteRecipients from './addReadWriteRecipients';
import findReadWriteRecipient from './findReadWriteRecipient';
import setHasSearchedDirectory from './setHasSearchedDirectory';
import setIsSearching from './setIsSearching';
import showHideFindResult from './showHideFindResult';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import isValidEmailAddress from '../utils/isValidEmailAddress';
import parseSuspectedDisplayNameEmailAddress from '../utils/parseSuspectedDisplayNameEmailAddress';
import { action } from 'satcheljs/lib/legacy';

export default action('resolveQueryStringToRecipient')(async function resolveQueryStringToRecipient(
    recipientWell: RecipientWellWithFindControlViewState,
    shouldDirectlyResolve: boolean,
    searchDirectory?: boolean,
    resolveIfSingle?: boolean
): Promise<void> {
    setHasSearchedDirectory(recipientWell, searchDirectory);
    let inputText = recipientWell.queryString.trim();
    if (inputText) {
        if (shouldDirectlyResolve) {
            setIsSearching(recipientWell, false /* isSearching */);
            // try to parse out a suspected name + email address combo
            let result = parseSuspectedDisplayNameEmailAddress(inputText);
            await addReadWriteRecipients(recipientWell, [
                {
                    isValid: isValidEmailAddress(result.EmailAddress.EmailAddress),
                    newPersona: result,
                },
            ]);
        } else {
            if (recipientWell.queryString.indexOf('@') >= 0 && recipientWell.inForceResolve) {
                setIsSearching(recipientWell, false /* isSearching */);
                await addReadWriteRecipients(recipientWell, [
                    {
                        isValid: isValidEmailAddress(inputText),
                        newPersona: null,
                        newEmailAddress: inputText,
                    },
                ]);
            } else {
                setIsSearching(recipientWell, true /* isSearching */);
                await findReadWriteRecipient(
                    recipientWell,
                    recipientWell.queryString,
                    searchDirectory,
                    resolveIfSingle
                );
            }
        }
    } else {
        // If query string is empty, hide find result with existing result cleared.
        setIsSearching(recipientWell, false /* isSearching */);
        showHideFindResult(
            recipientWell,
            true /* shouldShowFindResult */,
            true /* shouldClearFindResult */
        );
    }
});
